module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/361.74650e5c.png";